import { userService } from "@talentpair/api";
import { createCapHeader, createMeta } from "../../../components/hocs/createCapHeader";

const backFn = (): string => (userService.isDeactivated() ? "" : "/");

const title = "Settings";
export const SettingsHeader = createCapHeader(title, backFn, true);
export const SettingsMeta = createMeta(title);
